import React from 'react';

const SdkDoc: React.FC = () => {
  const basePath = import.meta.env.BASE_URL || '/';

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      background: '#0a0a0a',
      zIndex: 9999,
    }}>
      <iframe
        src={`${basePath}sdk-doc/index.html`}
        style={{
          width: '100%',
          height: '100%',
          border: 'none',
        }}
        title="SDK Documentation"
      />
    </div>
  );
};

export default SdkDoc;
